var pageData = window.dataLayer[0];

module.exports = {
    handle: (e, products) => {
        if (!products) {
            return;
        }

        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        const productsObj = JSON.parse(products);

        const productImpressions = productsObj.map(function (prod) {
            return {
                brand: prod.brand,
                category: prod.category,
                id: prod.id,
                name: prod.name,
                price: prod.price,
                quantity: prod.quantity,
                variant: prod.variant
            };
        });

        const productData = {
            event: 'eec.detail',
            ecommerce: {
                detail: {
                    actionField: { list: pageData.list},
                    products: productImpressions
                }
            }
        };

        if (productImpressions.length > 0) {
            const { customerId, emailAddress } = productsObj[0];
            customerId ? productData.userId = customerId : null;
            emailAddress ? productData.email = emailAddress : null;
        }

        dataLayer.push(productData);
    }
}